module.exports = __webpack_public_path__ + "static/img/szf.175b96b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/szf.jpg
// module id = wcaJ
// module chunks = 0